export interface LoyaltyTabsInterface {
  url: string;
  key: LoyaltyTabsType;
  hide?: boolean;
  disabled?: boolean;
}

export const LoyaltyTabsEnum = {
  quickView: 'quickView',
  ffp: 'ffp',
  points: 'points',
  pointHistory: 'pointHistory',
  attributes: 'attributes',
} as const;

export type LoyaltyTabsType =
  (typeof LoyaltyTabsEnum)[keyof typeof LoyaltyTabsEnum];

export const loyaltyTabsStatic: LoyaltyTabsInterface[] = [
  {
    url: 'quick-view',
    key: LoyaltyTabsEnum.quickView,
  },
  {
    url: 'points',
    key: LoyaltyTabsEnum.points,
  },
  {
    url: 'attributes',
    key: LoyaltyTabsEnum.attributes,
  },
  {
    url: 'ffp',
    key: LoyaltyTabsEnum.ffp,
  },
  {
    url: 'point-history',
    key: LoyaltyTabsEnum.pointHistory,
  },
];
